import { render, staticRenderFns } from "./printdub.vue?vue&type=template&id=4a778454&scoped=true&"
import script from "./printdub.vue?vue&type=script&lang=js&"
export * from "./printdub.vue?vue&type=script&lang=js&"
import style0 from "./printdub.vue?vue&type=style&index=0&id=4a778454&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a778454",
  null
  
)

export default component.exports